import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {
    NbThemeModule,
    NbButtonModule,
    NbTooltipModule,
    NbOverlayModule,
    NbLayoutModule,
    NbDatepickerModule,
    NbListModule,
    NbDialogModule,
    NbCardModule,
    NbSpinnerModule,
    NbBadgeModule,
    NbIconModule,
    NbMenuModule,
    NbTabsetModule,
    NbRouteTabsetModule,
    NbContextMenuModule,
} from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { NgxsModule } from '@ngxs/store';

import { AuthState } from '@app/auth/auth.state';
import { HeaderState } from '@app/header/header.state';
import { QueryState } from '@app/state/query-state/query.state';
import { SettingsState } from './state/query-state/settings.state';

import { AppComponent } from '@app/app.component';
import { LoginComponent } from './auth/login.component';
import { LogoutComponent } from '@app/auth/logout.component';
import { Route404Component } from '@app/route404/route404.component';
import { HeaderModule } from '@app/header/header.module';

import { env } from '@envs/env';
import { AppRoutingModule } from '@app/app-routing.module';
import { FlumeApiInterceptor } from '@app/utils/flume-api.interceptor';

@NgModule({
    declarations: [AppComponent, Route404Component, LoginComponent, LogoutComponent],
    imports: [
        BrowserAnimationsModule,
        AppRoutingModule,
        HeaderModule,
        HttpClientModule,
        NbEvaIconsModule,
        NbThemeModule.forRoot({ name: 'default' }),
        NbLayoutModule,
        NbButtonModule,
        NbCardModule,
        NbSpinnerModule,
        NbIconModule,
        NbBadgeModule,
        NbOverlayModule.forRoot(),
        NbDatepickerModule.forRoot(),
        NbTooltipModule,
        NbListModule,
        NbMenuModule.forRoot(),
        NbDialogModule.forRoot(),
        NbContextMenuModule,
        NbTabsetModule,
        NbRouteTabsetModule,
        NgxsModule.forRoot([AuthState, HeaderState, QueryState, SettingsState], {
            developmentMode: !env.production,
            selectorOptions: {
                suppressErrors: false,
                injectContainerState: false,
            },
        }),
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: FlumeApiInterceptor,
            multi: true,
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
